export const ERROR_SERVER_NOT_AVAILABLE = 0;
export const ERROR_INTERNAL_SERVER_FAILURE = 1;
export const ERROR_CLIENT_ERROR = 2;
